import { ITheme } from "@commons-monorepo/types";
import { UiButton } from "@ui-monorepo/components";

type SliderArrowProps = { className?: string; onClick?: () => void, userTheme?: ITheme };
const ArrowsSliderCover = ({ className, onClick, userTheme }: SliderArrowProps) => {
    return (
       <UiButton
        isBlack
        appearance='icon'
        className={className || ""}
        leftIcon={<span className='icon-arrow-right' />}
        onClick={onClick}
        theme={userTheme}
      />
    );
  };

export default ArrowsSliderCover;  